import { render, staticRenderFns } from "./Two.vue?vue&type=template&id=836d260c&"
import script from "./Two.vue?vue&type=script&lang=js&"
export * from "./Two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports